import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { reactive } from "vue";
import { store } from "@/stores/store";
import { BrandService, CLIENT_PROTOCOL_SECTIONS, CLIENT_PROTOCOL_SCOPE, buildClientProtocols, hasClientProtocolContent } from "@/services/brand.service";
export const clientProtocolsViewDialog = reactive({
  showDialog: false,
  brandId: null
});
export const closeClientProtocolsViewDialog = () => {
  clientProtocolsViewDialog.showDialog = false;
};
// brandId: show that brand's protocols (e.g. from a tracker row); without it,
// the brand selected in the header.
export const openClientProtocolsViewDialog = (brandId = null) => {
  clientProtocolsViewDialog.brandId = brandId || null;
  clientProtocolsViewDialog.showDialog = true;
};
export default {
  name: "ClientProtocolsViewDialog",
  data() {
    return {
      store,
      loading: false,
      brand: null,
      protocolSections: CLIENT_PROTOCOL_SECTIONS,
      protocolScope: CLIENT_PROTOCOL_SCOPE,
      activeProtocolKey: CLIENT_PROTOCOL_SECTIONS[0].key,
      activeSource: CLIENT_PROTOCOL_SCOPE.COMPANY,
      clientProtocolsViewDialog,
      closeClientProtocolsViewDialog
    };
  },
  computed: {
    brandProtocols() {
      return buildClientProtocols(this.brand?.client_protocols);
    },
    companyProtocols() {
      return buildClientProtocols(this.brand?.company?.client_protocols);
    },
    brandHasContent() {
      return hasClientProtocolContent(this.brand?.client_protocols);
    },
    companyHasContent() {
      return hasClientProtocolContent(this.brand?.company?.client_protocols);
    },
    // The selectable sources. Both appear (as tabs) only when the brand has its
    // own protocols AND the company has shared ones.
    sources() {
      const list = [];
      if (this.brandHasContent) {
        list.push({
          key: CLIENT_PROTOCOL_SCOPE.BRAND,
          label: "This brand"
        });
      }
      if (this.companyHasContent) {
        list.push({
          key: CLIENT_PROTOCOL_SCOPE.COMPANY,
          label: this.brand?.company?.company_name || "Company"
        });
      }
      if (list.length === 0) {
        // Nothing defined anywhere — show the company (shared) view, empty.
        list.push({
          key: CLIENT_PROTOCOL_SCOPE.COMPANY,
          label: this.brand?.company?.company_name || "Company"
        });
      }
      return list;
    },
    currentProtocols() {
      return this.activeSource === CLIENT_PROTOCOL_SCOPE.BRAND ? this.brandProtocols : this.companyProtocols;
    },
    activeProtocolLabel() {
      const section = this.protocolSections.find(s => s.key === this.activeProtocolKey);
      return section ? section.label : "";
    }
  },
  methods: {
    hasProtocolContent(key) {
      const value = this.currentProtocols?.[key] || "";
      return value.replace(/<(.|\n)*?>/g, "").trim().length > 0;
    },
    async load() {
      this.activeProtocolKey = this.protocolSections[0].key;
      // Client protocols are an internal staff-only reference.
      if (store.currentUser?.user_type !== "staff") {
        this.brand = null;
        closeClientProtocolsViewDialog();
        return;
      }
      const brandId = clientProtocolsViewDialog.brandId || store.currentBrand?.id;
      if (!brandId) {
        this.brand = null;
        return;
      }
      this.loading = true;
      this.brand = null;
      const {
        brand
      } = await BrandService.getBrand(brandId);
      this.brand = brand || (brandId === store.currentBrand?.id ? store.currentBrand : null);
      // Default to the brand's own protocols when present, otherwise the company's.
      this.activeSource = this.brandHasContent ? CLIENT_PROTOCOL_SCOPE.BRAND : CLIENT_PROTOCOL_SCOPE.COMPANY;
      this.loading = false;
    }
  },
  watch: {
    "clientProtocolsViewDialog.showDialog": {
      handler: function (val) {
        if (val) {
          this.load();
        }
      }
    }
  }
};